// src/ServiceReportPage.jsx
import React from "react";

export default function ServiceReportPage() {
  return (
    <div style={{ padding: 16 }}>
      <h2>Service Report Viewer</h2>
      <p>หน้านี้อยู่ระหว่างพัฒนา</p>
    </div>
  );
}
